// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__2JrBc","LiWithLink":"Projects_LiWithLink__2R06e","DivWith1Thumb":"Projects_DivWith1Thumb__26_QO","DivWith3Thumbs":"Projects_DivWith3Thumbs__P4Lb-"};